module.exports = __webpack_public_path__ + "static/video-thumbnail-4a9554d28acecacf8290565fa64cddcf.jpg";